
import moment from 'moment'

export default {
  methods: {
    useCellHtml (header, item, index) {
      return header.cellHtml || header.dateFormat || header.timeFormat
    },
    getCellHtml (header, item, index) {
      if (header.cellHtml) {
        if (typeof header.cellHtml === 'function') {
          return header.cellHtml(header, item, index)
        } else {
          return header.cellHtml
        }
      } else {
        const dateFormat = header.dateFormat
        const timeFormat = header.timeFormat
        if (dateFormat || timeFormat) {
          const result = []
          const value = this.getCellValue(header, item, index)
          if (value) {
            const dt = moment(value.length < 10 ? '2018-01-01 ' + value : value)
            if (dateFormat) {
              result.push('<span class="' + (timeFormat ? 'ftListDateTime' : 'ftListDate') + '">' + dt.format(dateFormat) + '</span>')
            }
            if (timeFormat) {
              result.push('<span class="' + (dateFormat ? 'ftListDateTime' : 'ftListTime') + '">' + dt.format(timeFormat) + '</span>')
            }
          }
          return result.join(' ')
        }
        return null
      }
    },
    getCellText (header, item, index) {
      if (header.dateFormat || header.timeFormat) return
      if (header.cellText) {
        if (typeof header.cellText === 'function') {
          return header.cellText(header, item, index)
        } else {
          return header.cellText
        }
      } else if (!header.slot) {
        return this.getCellValue(header, item, index)
      }
    },
    getCellValue (header, item, index) {
      const value = item[header.value]
      if (header.editor && header.editor.invert) {
        return !value
      }
      return value
    },
    getCellIcon (header, item, index) {
      if (header.cellIcon) {
        if (typeof header.cellIcon === 'function') {
          return header.cellIcon(header, item, index)
        } else {
          return header.cellIcon
        }
      } else {
        return false
      }
    },
    getCellClass (header, item, column, row) {
      const result = []
      if (header.cellClass) {
        if (typeof header.cellClass === 'function') {
          result.push(header.cellClass(header, item, column))
        } else {
          result.push(header.cellClass)
        }
      }
      return result
    },
    getCellIconClass (header, item, index) {
      if (header.cellIconClass) {
        if (typeof header.cellIconClass === 'function') {
          return header.cellIconClass(header, item, index)
        } else {
          return header.cellIconClass
        }
      } else {
        return false
      }
    }
  }
}
